export default __webpack_public_path__ + "static/media/buddy-hero.544ef98e.jpg";